import React from "react";
import styles from "../styles/banner01.module.css";
import { FaRegClock } from "react-icons/fa";
import { Link } from "react-router-dom";


export default function BannerDisponibilidad({
    titulo = "Comprueba nuestra disponibilidad",
    descripcion = "Reserva fecha y hora con uno de nuestros profesionales a través de nuestro sistema online.",
    linkTo = "/contacto",
    linkTexto = "CITA ONLINE",
    mostrarIcono = true 
}) {
    return (
        <section className={styles.banner}>
            <div className={styles.contenido}>
                <h2>{titulo}</h2>
                <p>{descripcion}</p>
                <Link to={linkTo} className={styles.boton}>
                    {linkTexto}
                    {mostrarIcono && <FaRegClock className={styles.icono} />} 
                </Link>
            </div>
        </section>
    );
}
